import React, { Component } from "react";
import styles from "./Dropdown.module.scss";
import { cx } from "../../../helpers/ClassNames.helper";
import { t } from "../../../helpers/translate.helper";

class Dropdown extends Component {

	constructor(props) {
		super(props);

		this.state = {
			open: false,
		};

		this.blurListener = (event) => {
			let target = event.target;

			while (target) {
				if (target === this.ref) {
					return false;
				}
				target = target.parentElement;
			}

			this.toggleOpen();
			return true;
		};
	}

	toggleOpen() {
		const newState = { open: !this.state.open };
		if (newState.open) {
			if (this.ref) {
				this.ref.scrollIntoView();

				let container;
				if (this.props.containerDistance != null) {
					container = this.ref;
					for (let i = 0; i < this.props.containerDistance; i++) {
						container = container.parentElement;
					}
				}

				if (!container) {
					container = document.body;
				}

				const rect = this.ref.getBoundingClientRect();
				const boundingRect = container.getBoundingClientRect();
				
				const boundingBottom = (boundingRect.top || boundingRect.y) + boundingRect.height;
				const compBottom = (rect.y || rect.top) + rect.height;

				newState.maxHeight = (boundingBottom - compBottom - 5);
			}
			document.addEventListener('click', this.blurListener);
		}
		else {
			document.removeEventListener('click', this.blurListener);
		}

		this.setState(newState);
	}

	bindSelect(entry, index) {
		return () => {
			this.toggleOpen();
			this.props.handleSelect(entry, index);
		};
	};



	render() {
		const { label, icon, entries, selectedIndex } = this.props;
		const { open, maxHeight } = this.state;

		let selected = entries[selectedIndex];
		selected = selected ? selected.title || (selected.title_translate && t(selected.title_translate)) : ' ';

		return (
			<div className={styles.host} ref={ref => this.ref = ref}>
				{label && <label>{icon && <i className={"fas fa-" + icon}></i>}{label}</label>}
				<div className={styles.dropdown}>
					<button
						className={cx(styles.button, open && styles.open)}
						type="button"
						onClick={this.toggleOpen.bind(this)}>
						{selected}
					</button>
					{
						open &&
						<div
							className={cx(styles.entries, '__scrollbar_dark')}
							style={{ maxHeight: maxHeight + 'px' }}
						>
							{
								entries &&
								entries
									.map((entry, index) => index !== selectedIndex
										? (
											<div
												className={styles.entry}
												key={entry.title || entry.title_translate}
												onClick={this.bindSelect(entry, index)}>
												{entry.title || (entry.title_translate && t(entry.title_translate))}
											</div>)
										: null)
							}
						</div>
					}
				</div>
			</div >
		);
	}
}

Dropdown.defaultProps = {
	selectedIndex: 0,
	handleSelect: (entry, index) => console.log('No dropdown handler set!', entry, index)
};


export default Dropdown;
